import React, { useState } from "react";

const DMInvitePopup = ({ applicantEmail, applicantName, onClose, navigate }) => {
  const [message, setMessage] = useState("");
  const currentUserEmail = localStorage.getItem("userEmail");

  const sendMessage = async () => {
    if (!message.trim()) return alert("Message cannot be empty!");

    try {
      const chatId = [currentUserEmail, applicantEmail].sort().join("_");

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/chats/${chatId}/send`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ sender: currentUserEmail, message }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        onClose();
        navigate(`/messages/${chatId}`);
      } else {
        alert(`Error: ${data.message}`);
      }
    } catch (error) {
      console.error("❌ Error:", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-sm">
        <h3 className="text-lg font-semibold mb-3">Send DM to {applicantName}</h3>
        <textarea
          className="w-full h-24 p-2 border border-gray-300 rounded-md text-sm resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type your message..."
        />
        <div className="flex justify-between mt-4">
          <button
            onClick={onClose}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-medium px-4 py-2 rounded-md"
          >
            Cancel
          </button>
          <button
            onClick={sendMessage}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-md"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default DMInvitePopup;
